﻿export interface IRequestForDonorReview {
    id: number,
    swapNumber: string,
    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenter: string,
    remoteDonorCenterId: number,
    remoteDonorCenter: string,
    recipientId: number,
    recipientAlias: string,
    recipientCenterId: number,
    recipientCenter: string,
    dateRequested: string,
    responseDeadline: string,
    responseDeadlineActual: string,
    daysLate: number,
    daysRemaining: number,
    numberOfRequests: number,
    fullyConfident: string,
    safeKey: string,
    centerResponses: number,
    xmSignOff: string
}
